import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';

const StyledLoadingButton = styled(LoadingButton)({
  height: '56px',
  whiteSpace: 'nowrap',
  fontWeight: 600,
  width: '90px',
  marginLeft: '5px',
});

export default StyledLoadingButton;
